// Professional placeholder legal content — structured for later review/replacement.
// No fabricated company details, addresses, VAT numbers or legal entities.

const disclaimerBlock = {
  h: "Important disclaimer",
  p: [
    "Velora Intelligence provides informational and analytical tools for cryptocurrency markets. It does not provide financial, investment, legal, or tax advice.",
    "Cryptocurrency investments involve substantial risk, including the possible loss of capital. You are solely responsible for your own decisions.",
  ],
};

export const legalContent = {
  privacy: {
    label: "Legal",
    title: "Privacy Policy",
    updated: "This is placeholder content pending final legal review.",
    desc: "How Velora Intelligence handles information when you use our website and app.",
    sections: [
      {
        h: "Overview",
        p: [
          "This Privacy Policy explains, in general terms, how Velora Intelligence approaches privacy across our website and mobile application. This document is placeholder content and will be replaced with final, reviewed legal text.",
        ],
      },
      {
        h: "Information we may handle",
        p: [
          "We aim to collect only the information necessary to provide and improve the platform. This may include basic account information you provide and usage information that helps us operate the service.",
          "We do not sell your personal information.",
        ],
      },
      {
        h: "How information is used",
        p: [
          "Information may be used to operate, maintain and improve the platform, to provide analytical features, and to communicate important service updates.",
        ],
      },
      {
        h: "Security",
        p: [
          "We follow good security practices designed to protect information. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
        ],
      },
      {
        h: "Your choices",
        p: [
          "You may contact us to ask questions about how your information is handled. Where applicable, you may have rights regarding your personal information.",
        ],
      },
      {
        h: "Contact",
        p: ["Questions about privacy can be sent to support@velora.ai."],
      },
    ],
  },
  terms: {
    label: "Legal",
    title: "Terms of Service",
    updated: "This is placeholder content pending final legal review.",
    desc: "The terms that govern your use of Velora Intelligence.",
    sections: [
      {
        h: "Acceptance of terms",
        p: [
          "By using the Velora Intelligence website or app, you agree to these terms. This document is placeholder content and will be replaced with final, reviewed legal text.",
        ],
      },
      {
        h: "Nature of the service",
        p: [
          "Velora Intelligence is an informational and analytical platform for cryptocurrency markets. It is not a broker, exchange, investment adviser or financial institution, and it does not execute trades or hold funds.",
        ],
      },
      disclaimerBlock,
      {
        h: "Acceptable use",
        p: [
          "You agree to use the platform lawfully and not to misuse, disrupt or attempt to gain unauthorized access to the service.",
        ],
      },
      {
        h: "Limitation of liability",
        p: [
          "To the maximum extent permitted by law, Velora Intelligence is not liable for decisions made using the platform or for any losses arising from cryptocurrency activity.",
        ],
      },
      {
        h: "Changes",
        p: [
          "We may update these terms from time to time. Continued use of the platform indicates acceptance of the updated terms.",
        ],
      },
    ],
  },
  refund: {
    label: "Legal",
    title: "Refund Policy",
    updated: "This is placeholder content pending final legal review.",
    desc: "How subscriptions and refunds are handled for Velora Intelligence.",
    sections: [
      {
        h: "Subscriptions",
        p: [
          "Premium subscriptions are offered through the mobile application. This document is placeholder content and will be replaced with final, reviewed legal text.",
        ],
      },
      {
        h: "App store billing",
        p: [
          "Where subscriptions are purchased through the Apple App Store or Google Play, billing, cancellations and refunds are subject to the respective store's policies and processes.",
        ],
      },
      {
        h: "Requesting help",
        p: [
          "If you have a billing question, please contact us at support@velora.ai and we will do our best to assist within the applicable store policies.",
        ],
      },
    ],
  },
  cookie: {
    label: "Legal",
    title: "Cookie Notice",
    updated: "This is placeholder content pending final legal review.",
    desc: "How Velora Intelligence uses cookies and similar technologies.",
    sections: [
      {
        h: "What cookies are",
        p: [
          "Cookies are small files stored on your device that help websites function and understand usage. This document is placeholder content and will be replaced with final, reviewed legal text.",
        ],
      },
      {
        h: "How we use them",
        p: [
          "We may use essential cookies to operate the website and, where applicable, analytics to understand how the site is used so we can improve it.",
        ],
      },
      {
        h: "Managing cookies",
        p: [
          "Most browsers let you control cookies through their settings. Disabling some cookies may affect how the website functions.",
        ],
      },
    ],
  },
};
